import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-user-change-profile',
  templateUrl: './user-change-profile.component.html',
  styleUrls: ['./user-change-profile.component.scss']
})
export class UserChangeProfileComponent implements OnInit {
  public userForm: FormGroup;
  public isLoading = false;

  constructor(
    private fb: FormBuilder,
    private userService: AuthService,
    private api: MgService
  ) {
    this.userForm = this.fb.group({
      id: [this.userService.user.id, [Validators.required]],
      name: [this.userService.user.name, [Validators.required]],
      email: [this.userService.user.email, [Validators.required]],
      mobile: [this.userService.user.mobile, [Validators.required]],
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    if (this.userForm.invalid) {
      return;
    }

    this.isLoading = true;

    this.api.saveBusinessUser(this.userForm.value)
      .toPromise()
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
